import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  tilteBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '20px',
  },

  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',

    // alignItems: 'center',
    // justifyContent: 'space-between',
    marginBottom: '15px',
  },

  flexSpaceBtw: {
    display: 'flex',
    //alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
  },

  dishWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: '8px',
  },

  dish: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  promoCodeBtnWrapper: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '15px',
    marginTop: '7px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      rowGap: '10px',
    },
  },

  promoCodeError: {
    position: 'absolute',
    top: '60px',
    zIndex: 10,
  },

  mainContainer: {
    padding: '12px',
    maxWidth: '600px',
    margin: '0 auto',

    [theme.breakpoints.down('md')]: {
      padding: '0',
    },
  },

  checkoutBtnWrapper: {
    marginTop: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  desktopCheckoutBtn: {
    width: '300px',
    borderRadius: '55px',
    height: '76px',
    [theme.breakpoints.up('lg')]: {
      width: '425px',
    },
  },

  checkoutBtn: {
    position: 'fixed',
    bottom: '0',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});
